import { render } from "./AdminDriverEdit.vue?vue&type=template&id=b3110426&scoped=true&ts=true&lang=true"
import script from "./AdminDriverEdit.vue?vue&type=script&lang=ts"
export * from "./AdminDriverEdit.vue?vue&type=script&lang=ts"

import "./AdminDriverEdit.vue?vue&type=style&index=0&id=b3110426&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3110426"]])

export default __exports__